module.exports = __webpack_public_path__ + "static/img/amugilogo.4cc7b35b.png";